<template>
  <div class="content">
    <div class="container-fluid h-100">
      <div class="row h-100">
        <div class="col h-100">
          <card-item>
            <div class="d-flex justify-content-end">
              <button class="btn btn-danger btn-sm" @click="volver">
                Volver
              </button>
            </div>
          </card-item>
          <card-item
            class="striped-tabled-with-hover"
            body-classes="table-full-width table-responsive"
          >
            <template slot="header">
              <div class="d-flex justify-content-between">
                <div>
                  <h4 class="card-title">
                    Cuenta del cliente: {{ nombreCliente }}
                  </h4>
                  <p class="card-category">Listado</p>
                </div>
                <div class="button-group">
                  <button @click="exportarExcel" class="btn btn-primary">
                    Exportar Excel
                  </button>
                </div>
              </div>
            </template>

            <div class="container-fluid h-100">
              <div class="row">
                <div class="col">
                  <div class="form-group">
                    <div class="row align-items-center">
                      <div class="col-12 col-md-9 form-group">
                        <label for="quickFilter" class="label"
                          >Filtro rapido</label
                        >
                        <input
                          type="text"
                          class="form-control"
                          id="quickFilter"
                          v-model="quickFilter"
                        />
                      </div>
                      <div class="col-12 col-md-3 form-group">
                        <label for="fechaDesde" class="label">Desde:</label>
                        <input
                          type="date"
                          v-model="fechaFiltro"
                          class="form-control"
                          id="fechaDesde"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row" style="height: 100%">
                <div class="col" style="position: relative; height: 100%">
                  <ag-grid-vue
                    style="width: 100%; height: 60vh"
                    class="ag-theme-alpine"
                    @gridReady="onGridReady"
                    :columnDefs="columnDefs"
                    :defaultColDef="defaultColDef"
                    :gridOptions="gridOptions"
                    :rowData="dataFiltrada"
                    :excelStyles="excelStyles"
                    :getContextMenuItems="getContextMenuItems"
                  >
                  </ag-grid-vue>
                </div>
              </div>
            </div>
          </card-item>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { AgGridVue } from "ag-grid-vue";
import { get } from "lodash-es";
import axios from "axios";
import { formatM } from "@/lib/utils/accountingJsFns";
import moment from "moment";
import NombreCliente from "../shared/NombreCliente";

export default {
  name: "CuentaDeCliente",
  components: { AgGridVue },
  mixins: [NombreCliente],
  computed: {
    dataFiltrada() {
      if (!this.fechaFiltro) {
        return this.cuentaCliente;
      }
      const fechaFiltroMoment = moment(this.fechaFiltro);
      return this.cuentaCliente.filter((data) => {
        const fechaData = moment(data.Fecha);

        return fechaData.isAfter(fechaFiltroMoment);
      });
    },
  },
  beforeMount() {
    this.gridOptions = {
      statusBar: {
        statusPanels: [
          {
            statusPanel: "agTotalAndFilteredRowCountComponent",
            align: "left",
          },
          {
            statusPanel: "agTotalRowCountComponent",
            align: "center",
          },
          { statusPanel: "agFilteredRowCountComponent" },
          { statusPanel: "agSelectedRowCountComponent" },
          { statusPanel: "agAggregationComponent" },
        ],
      },
      enableClipboard: true,
      enableRangeSelection: true,
      suppressCopyRowsToClipboard: false,
    };

    this.excelStyles = [
      {
        id: "header-title",
        font: { bold: true },
        alignment: {
          vertical: "Center",
          horizontal: "Center",
        },
      },
      {
        id: "text-center",
        alignment: {
          vertical: "Center",
          horizontal: "Center",
        },
      },
    ];
  },
  methods: {
    volver() {
      this.$router.push(`/admin/clientes/`);
    },
    async getData() {
      try {
        const resp = await axios.post("/execute", {
          method: "CLI.GetCuentaDeCliente",
          parameters: [
            { name: "id_cliente", value: this.$route.params.id_cliente },
          ],
        });
        if (resp.data.ok) {
          this.cuentaCliente = get(resp, "data.result[0]", []);
        } else {
          this.$msgBoxOk(resp.message);
        }
        return resp;
      } catch (e) {
        this.$msgBoxOk(e);
      }
    },
    exportarExcel() {
      const fechaHoy = moment().format("DD-MM-YYYY");
      this.gridApi.exportDataAsExcel({
        fileName: `EC_${this.nombreCliente}_al_${fechaHoy}.xlsx`,
        sheetName: `${this.nombreCliente}`,
      });
    },
    onGridReady(params) {
      this.gridApi = params.api;
      this.columnApi = params.columnApi;

      this.gridApi.showLoadingOverlay();
      this.getData().then(() => {
        this.gridApi.hideOverlay();
      });

      this.getNombreCliente(this.$route.params.id_cliente).then((resp) => {
        if (get(resp, "ok", true) === false) {
          this.$msgBoxOk(resp.message);
        }
      });
    },
    getContextMenuItems() {
      return ["copy", "excelExport"];
    },
  },
  data: () => ({
    clienteId: null,
    cuentaCliente: [],
    excelStyles: null,
    quickFilter: "",
    gridOptions: null,
    gridApi: null,
    columnApi: null,
    fechaFiltro: null,
    defaultColDef: {
      sortable: true,
      filter: true,
      resizable: true,
      enableCellTextSelection: true,
      ensureDomOrder: true,
    },
    columnDefs: [
      {
        flex: 1,
        field: "Fecha",
        headerClass: "header-title",
        cellClass: "text-center",
        maxWidth: 120,
        minWidth: 110,
        cellRenderer: (params) => {
          const fechaFormat = moment(params.data.Fecha).format("DD-MM-YYYY");
          return fechaFormat;
        },
        getQuickFilterText: (params) =>
          moment(params.data.Fecha).format("DD-MM-YYYY"),
      },
      {
        flex: 1,
        minWidth: 300,
        wrapText: true,
        autoHeight: true,
        headerClass: "header-title",
        cellClass: "text-center",
        field: "Concepto",
      },
      {
        flex: 1,
        maxWidth: 200,
        minWidth: 200,
        field: "Débito",
        headerClass: "header-title",
        cellClass: "text-center",
        cellRenderer: (params) => formatM(Number(params.data["Débito"])),
        getQuickFilterText: (params) => params.data["Débito"],
      },
      {
        flex: 1,
        maxWidth: 200,
        minWidth: 200,
        field: "Crédito",
        headerClass: "header-title",
        cellClass: "text-center",
        cellRenderer: (params) => formatM(Number(params.data["Crédito"])),
        getQuickFilterText: (params) => params.data["Crédito"],
      },
      {
        flex: 1,
        maxWidth: 200,
        minWidth: 200,
        field: "Saldo",
        headerClass: "header-title",
        cellClass: "text-center",
        cellRenderer: (params) => {
          const saldo = formatM(Number(params.data.Saldo));
          return saldo;
        },
        getQuickFilterText: (params) => params.data.Saldo,
      },
    ],
  }),
  watch: {
    quickFilter(val) {
      this.gridApi.setQuickFilter(val);
    },
  },
};
</script>
<style></style>
